<template>
  <connection-failure-base class="consent-failure" :close-action="closeAction" :buttons="buttons">
    <template v-slot:title>
        <div>החיבור לא הצליח,</div>
        <div>אפשר לנסות שוב!</div>
    </template>
  </connection-failure-base>
</template>

<script>
import Intercom from '@/Intercom';
import Segment from '@/Segment';
import { setObkRetry } from '@/base-components/credentials/credentials-retry-utils';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow.vue';
import CreateCredentialsFlow
  from '@/pages/responsive-pages/authenticated/onboard2/steps/create-credentials-flow/CreateCredentialsFlow.vue';
import { mapActions, mapGetters } from 'vuex';
import ConnectionFailureBase from './ConnectionFailureBase';

export default {
  name: 'ConsentFailure',
  components: {
    ConnectionFailureBase,
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('OBKConsentApplyFailureShown', { source: this.sourceName, isOnboarding: !this.onboardingCompleted });
    Intercom.hideLauncher();
  },
  computed: {
    ...mapGetters('onboardingState', ['onboardingCompleted']),
    buttons() {
      return [{
        action: this.tryAgain,
        title: 'לנסות שוב',
        size: 'slim',
      }];
    },
    sourceName() {
      return this.source.displayName;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    tryAgain() {
      setObkRetry(this.sourceName);
      Segment.trackUserGot('OBKConsentApplyFailure_TryAgainClicked', { source: this.sourceName, isOnboarding: !this.onboardingCompleted });
      this.openModal({
        component: this.onboardingCompleted ? AddCredentialsFlow : CreateCredentialsFlow,
        props: {
          sourceNameToAdd: this.sourceName,
        },
        popupAlignment: 'full-screen',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .consent-failure {
    .title {
      font-size: 24px;
      line-height: 32px;
      font-weight: bold;
      font-family: SimplerPro;
      margin-bottom: 24px;
    }
    .subtitle {
      font-size: 18px;
      line-height: 25px;
    }
  }

</style>
